<!-- eslint-disable max-len -->
<template>
    <a class="extension-link" href="https://chromewebstore.google.com/detail/arbitracer-extension/pdlkipdelhnincphjpkcoiaafohdpjbl" title="arbitracer Extension" target="_blank">
        <img src="@/assets/svg/icon.svg" width="23" />
    </a>
    <header id="header" class="navbar navbar-expand-lg navbar-bordered bg-white">
        <div class="container">
            <Logo></Logo>
            <SecondaryContent></SecondaryContent>
            <Toggler></Toggler>
            <NavBar></NavBar>
        </div>
    </header>
</template>

<script>
import Logo from '@/components/Header/Logo.vue'
import SecondaryContent from '@/components/Header/SecondaryContent.vue'
import Toggler from '@/components/Header/Toggler.vue'
import NavBar from '@/components/Header/NavBar.vue'

export default {
    name: 'Header',
    components: {
        Logo,
        SecondaryContent,
        Toggler,
        NavBar,
    },
}
</script>

<style lang="scss">
.extension-link {
    position: fixed;
    bottom: 15px;
    left: 30px;
    z-index: 10;
    background-color: #fffaf2;
    border: 1px solid #e7eaf3;
    padding: 5px;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 10px 0px #f3b355;

    svg {
        color: #fff;
    }
}
@media (width < 768px) {
    .sm-hidden {
        display: none !important;
    }
}
@media (width > 768px) {
    .sm-hidden {
        display: flex !important;
    }
}
</style>
